import type { FaireProductEntity } from "../../entity_types/product";

export const p_64mc3jtdrs: FaireProductEntity = {
  token: "p_64mc3jtdrs",
  type: "product",
  name: "Square-Neck Smocked Denim Trapeze Dress",
  brandToken: "b_6ekrb4hxre",
  brandName: "Mustard Seed",
  imageUrl:
    "https://cdn.faire.com/fastly/5f4f5a088a330d4ea8fb13b039de740221c545f5e4b0c1dd6cb3d9c473024339.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/3d5040527f9b3e019b8e5a973307062f81284f5f42a40b87e23cec804ca14cae.jpeg",
    "https://cdn.faire.com/fastly/b2baf890f8185c8371800be04a5de3d79fa423ed761f09d9cdbcd9bc246d3444.jpeg",
    "https://cdn.faire.com/fastly/fa3b5714089e08c409b3aa13bee1c1c4652438c41fe7c850df0843d26b4df7ae.jpeg",
    "https://cdn.faire.com/fastly/3870bd8f871f401b1fba8d7e327546c795527b6b2828f423861eabb3870064a4.jpeg",
    "https://cdn.faire.com/fastly/a4bc56e2259f1c648c9388781267d1aa88b434a5282f8fcd123a0ea534a69746.jpeg",
    "https://cdn.faire.com/fastly/35d4fabbc60d844b0023f385262160278bfbe53967bf64f8d74a95618ff36a62.jpeg",
    "https://cdn.faire.com/fastly/e48d79c07ab462d7210ed3b4a183325690baa119cceb490d2837194c4c8be100.jpeg",
    "https://cdn.faire.com/fastly/f33aec96f884ac5671179cf68eba9efda1d378a3b32cfb353b1fe18593ff5e8f.jpeg",
  ],
  priceDollars: 160.5,
  description:
    "Crafted from a lightweight denim with a soft, enzyme-washed hand-feel, this dress offers structure with a breathable matte finish. An expansive square neckline tops a densely smocked bodice, creating a comfortable empire-line fit. The body cascades into a gentle A-line trapeze shape, balanced by three-quarter puff sleeves that finish with adjustable self-fabric tie cuffs.\n\nSearch Keywords: Denim Dress, Smocked Dress, Square Neck Dress, Puff Sleeve Dress, Empire Waist Dress, Lightweight Denim, Trapeze Dress, Woven Dress, Tie Sleeve Detail, Above Knee Dress\n\nSKU DS1071\nSize + Fit\n\n- Model is wearing size S\n- Measurements taken from size S\n- 5'9\" / 175CM\n- 32-24-34",
  tags: [],
  msrpDollars: 321,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T06:19:57.511Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
